/* ==========================================================================
   DEPOIMENTOS
   Celular: fileira que rola com o dedo, com dica de "deslize" e SEM laco -
   laco automatico no toque briga com a rolagem da pessoa.
   Desktop: esteira que anda sozinha e PARA quando o ponteiro entra ou quando
   alguem clica num cartao (para poder ler ate o fim).
   ========================================================================== */
BV.quandoPronto(function () {
  const esteira = document.getElementById('depo-esteira');
  if (!esteira) return;
  const cartoes = Array.from(esteira.children);
  if (!cartoes.length) return;

  const estreita = window.matchMedia('(max-width: 900px)');
  if (estreita.matches) { BV.regua(esteira); return; }
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  let travado = false, parado = false, pos = 0, ultimo = 0;
  const VELOCIDADE = 0.35;   /* px por ms */

  /* Duplica os cartoes uma vez para a volta nao ter buraco. */
  cartoes.forEach(c => esteira.appendChild(c.cloneNode(true)));

  function quadro(t) {
    if (!ultimo) ultimo = t;
    const dt = t - ultimo;
    ultimo = t;
    if (!travado && !parado) {
      pos += VELOCIDADE * dt;
      const metade = esteira.scrollWidth / 2;
      if (pos >= metade) pos -= metade;
      esteira.scrollLeft = pos;
    }
    requestAnimationFrame(quadro);
  }
  requestAnimationFrame(quadro);

  esteira.addEventListener('mouseenter', () => { parado = true; });
  esteira.addEventListener('mouseleave', () => { parado = false; });
  esteira.addEventListener('click', function (ev) {
    const card = ev.target.closest('.depo__card');
    travado = !!card;
    esteira.querySelectorAll('.depo__card').forEach(c => c.classList.toggle('lendo', c === card));
  });
  document.addEventListener('click', function (ev) {
    if (!ev.target.closest('#depo-esteira')) {
      travado = false;
      esteira.querySelectorAll('.lendo').forEach(c => c.classList.remove('lendo'));
    }
  });

  const obs = new IntersectionObserver(e => { parado = !e[0].isIntersecting; }, { threshold: 0 });
  obs.observe(esteira);
});
